module.exports = __webpack_public_path__ + "static/media/mission_getreward.b8b2d766.png";